<template>
  <span
    >I agree to the
    <a href="https://www.bloomingdales.com/customer-service/articles/bloomingdales-terms-of-use" class="link-body" target="_blank"
      >Terms & Conditions<span class="show-for-sr">Opens a new window</span></a
    ></span
  >
</template>

<style lang="scss" scoped brand="bcom">
@import '@core/csg/src/scss/typography/typography-mixins.scss';

span {
  @include body(regular);
}
</style>
